// Logos officiels — versions complètes (septembre 2026).
// size: "sq" = logo plutôt carré (hauteur légèrement réduite pour équilibrer visuellement la grille)
// darkBg: true = version officielle claire du logo (texte blanc), affichée sur pastille sombre du site
export const PARTNER_LOGOS = [
    { name: "USAID", src: "/assets/logos/usaid.png" },
    { name: "EBRD", src: "/assets/logos/ebrd.jpg" },
    { name: "GIZ", src: "/assets/logos/giz.png", size: "sq" },
    { name: "Expertise France", src: "/assets/logos/expertise-france.jpg" },
    { name: "SIPPO", src: "/assets/logos/sippo.png" },
    { name: "sequa", src: "/assets/logos/sequa.png" },
    { name: "Partners in Transformation", src: "/assets/logos/ipd.png" },
    { name: "CEPEX — Tunisia Export", src: "/assets/logos/cepex.jpg" },
    { name: "AMDIE", src: "/assets/logos/amdie-full.png" },
    { name: "ASMEX", src: "/assets/logos/asmex.png" },
    { name: "Morocco Foodex", src: "/assets/logos/morocco-foodex.png" },
    { name: "CCIS Sfax", src: "/assets/logos/ccis.jpg", size: "sq" },
    { name: "CTICI", src: "/assets/logos/ctici.jpg" },
    { name: "Accelerateur.M", src: "/assets/logos/accelerateur-m.svg" },
    { name: "Marseille Innovation", src: "/assets/logos/marseille-innovation.png" },
    { name: "SPARK", src: "/assets/logos/spark.svg" },
];
